/* eslint-disable unicorn/prefer-module */
import {
  FaCarSide,
  FaChartLine,
  FaDog,
  FaPlane,
  FaShoppingCart,
  FaTaxi,
  FaTshirt,
  FaWifi,
  FaWineBottle,
} from "react-icons/fa";
import { GiSmartphone, GiHamburger, GiPerfumeBottle } from "react-icons/gi";
import { MdDeliveryDining } from "react-icons/md";
import { Link } from "react-router-dom";
import { Header } from "../../components";
import styles from "./Categoria.module.scss";

const ipsosLogo = require("../../img/ipsos-logo.png");

const CATEGORIAS = [
  { path: "/categorias/automotriz", icon: FaCarSide, text: "AUTOMOTRIZ" },
  { path: "/categorias/bebidas", icon: FaWineBottle, text: "BEBIDAS" },
  { path: "/categorias/delivery", icon: MdDeliveryDining, text: "DELIVERY" },
  { path: "/categorias/fastfood", icon: GiHamburger, text: "FAST FOOD" },
  { path: "/categorias/inversiones", icon: FaChartLine, text: "INVERSIONES" },
  { path: "/categorias/mascotas", icon: FaDog, text: "MASCOTAS" },
  { path: "/categorias/perfumes", icon: GiPerfumeBottle, text: "PERFUMES" },
  { path: "/categorias/smartphones", icon: GiSmartphone, text: "SMARTPHONES" },
  { path: "/categorias/retail", icon: FaShoppingCart, text: "SUPER" },
  { path: "/categorias/telcos", icon: FaWifi, text: "TELCOS" },
  { path: "/categorias/transporte", icon: FaTaxi, text: "TRANSPORTE" },
  { path: "/categorias/viajes", icon: FaPlane, text: "VIAJES" },
  { path: "/categorias/vestimenta", icon: FaTshirt, text: "VESTIMENTA" },
];

export const Categoria = () => (
  <div className={styles.Categoria}>
    <Header leftContent={<h1 className={styles.titulo}>ANÁLISIS CATEGORÍAS MERCADO</h1>} />

    <div className={styles.content}>
      {/* Declaración IPSOS */}
      <div className={styles.ipsosDeclaracion}>
        <div className={styles.ipsosTexto}>
          <p>
            Herramientas basadas en la investigación <strong>IPSOS Wecast 2025</strong>.
          </p>
          <p>Permiten simular escenarios y evidenciar el potencial comercial para marcas de cada sector.</p>
          <p>
            Los datos IPSOS se destacan con <span className={styles.badgeIpsos}>etiquetas</span> acompañado de un
            razonamiento comercial para <strong>dimensionar mercados</strong> y{" "}
            <strong>cuantificar oportunidades</strong>.
          </p>
        </div>
        <img src={ipsosLogo} alt="IPSOS" className={styles.ipsosLogo} />
      </div>

      <div className={styles.botones}>
        {CATEGORIAS.map((cat) => (
          <Link key={cat.path} to={cat.path} className={styles.link}>
            <cat.icon className={styles.icon} />
            <span>{cat.text}</span>
          </Link>
        ))}
      </div>
    </div>
  </div>
);
